import React, { useState } from 'react';
import { cognitoService } from '../../services/cognitoService';
import { Link, useNavigate } from 'react-router-dom';
import AuthLayout from '../layout/AuthLayout';

const ForgotPassword = () => {
  const [username, setUsername] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [isResetting, setIsResetting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    try {
      await cognitoService.forgotPassword(username);
      setIsResetting(true);
      setSuccess('Reset code sent to your email. Please check your inbox.');
    } catch (error) {
      setError('Failed to send reset code. Please check your username and try again.');
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    try {
      await cognitoService.forgotPasswordSubmit(username, code, newPassword);
      setSuccess('Password reset successful. You can now login with your new password.');
      setTimeout(() => navigate('/auth/login'), 2000);
    } catch (error) {
      setError('Failed to reset password. Please check your code and try again.');
    }
  };

  return (
    <AuthLayout>
      <div>
        <h2 className="text-center text-3xl font-extrabold text-gray-900">
          {isResetting ? 'Reset your password' : 'Forgot your password?'}
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          {isResetting ? 'Enter the code sent to your email and your new password' : 'No worries, we will send you reset instructions.'}
        </p>
      </div>
      {isResetting ? (
        <form className="mt-6 space-y-4" onSubmit={handleResetPassword}>
          <input type="hidden" name="remember" value="true" />
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="reset-code" className="sr-only">Reset Code</label>
              <input
                id="reset-code"
                name="reset-code"
                type="text"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                placeholder="Reset Code"
                value={code}
                onChange={(e) => setCode(e.target.value)}
              />
            </div>
            <div>
              <label htmlFor="new-password" className="sr-only">New Password</label>
              <input
                id="new-password"
                name="new-password"
                type="password"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                placeholder="New Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </div>
          </div>

          {error && <p className="mt-2 text-center text-sm text-red-600">{error}</p>}
          {success && <p className="mt-2 text-center text-sm text-green-600">{success}</p>}

          <div>
            <button
              type="submit"
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Reset Password
            </button>
          </div>
        </form>
      ) : (
        <form className="mt-6 space-y-4" onSubmit={handleForgotPassword}>
          <input type="hidden" name="remember" value="true" />
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="username" className="sr-only">Username</label>
              <input
                id="username"
                name="username"
                type="text"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
          </div>

          {error && <p className="mt-2 text-center text-sm text-red-600">{error}</p>}
          {success && <p className="mt-2 text-center text-sm text-green-600">{success}</p>}

          <div>
            <button
              type="submit"
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Send Reset Code
            </button>
          </div>
        </form>
      )}
      <div className="mt-4 flex items-center justify-between">
        <div className="text-sm">
          <Link to="/auth/login" className="font-medium text-indigo-600 hover:text-indigo-500">
            Remember your password?
          </Link>
        </div>
        <div className="text-sm">
          <Link to="/auth/signup" className="font-medium text-indigo-600 hover:text-indigo-500">
            Need an account?
          </Link>
        </div>
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;